import 'jquery';
import 'ion-rangeslider';

/**
* Add focus class to ion-rangeSlider:
* .irs-line is always getting focus when you target the slider.
* This is done for keyboard control.
* Here we add focused class to parent of irs-line to be able to style the irs-slider
*/
export class UnifyRangeslider {
    constructor() {
        this.addFocusEvents();
    }

    addFocusEvents() {
        var that = this;
        $(document).ready(function () {
            $('body').on('focusin', '.irs-line', function () {
                that.setFocus($(this));
            });
            $('body').on('focusout', '.irs-line', function () {
                that.removeFocus($(this));
            });
        });
    }

    setFocus($target) {
        var $irs = $target.closest('.irs');
        $irs.addClass('focused');
    }

    removeFocus($target) {
        var $irs = $target.closest('.irs');
        $irs.removeClass('focused');
    }
}